<template>
  <div class="loader__small">
    <div class="loader__circle blue"></div>
    <div class="loader__circle blue"></div>
    <div class="loader__circle blue"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loader__small {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 200px;
  justify-content: center;
  align-items: center;
}

.blue {
  background: $dark-blue;
  margin: 0 6px;
}
</style>
